<div
  class="asset-card card-0 card-hover full-width flex align-items-center justify-content-between p-16 cursor-pointer"
  (click)="onClick()"
>
  <div class="asset-card__info flex align-items-center gap-16">
    <erc20-token-logo
      class="asset-card__logo"
      [ticker]="token()?.symbol || ''"
      [address]="token()?.address || ''"
      [size]="'lg'"
    />
    <div class="flex column gap-4">
      <div class="text-gray-90">{{ token()?.name || "" }}</div>
      <div class="text-gray-60 typo-text-1 asset-card__meta">
        {{ token()?.balance || 0 | number: "1.0-4" }}
        &nbsp;{{ token()?.symbol || "" | uppercase }}
      </div>
    </div>
  </div>
  <div class="asset-card__usd-info flex column align-items-end">
    @if (token(); as t) {
      @if (t.tokenPriceUSD !== undefined && t.tokenPriceUSD !== null) {
        <div class="text-gray-90">
          ${{ (t.balance || 0) * t.tokenPriceUSD | number: "1.2-2" }}
        </div>
        <div class="text-gray-60 typo-text-1 asset-card__usd-meta">
          @if (t.tokenPriceUSD >= 0.01) {
            ${{ t.tokenPriceUSD | number: "1.2-2" }}
          } @else {
            ${{ t.tokenPriceUSD | number: "1.2-8" }}
          }
        </div>
      } @else {
        <div class="text-gray-90">—</div>
        <div class="text-gray-60 typo-text-1 asset-card__usd-meta">—</div>
      }
    } @else {
      <div class="text-gray-90">—</div>
      <div class="text-gray-60 typo-text-1 asset-card__usd-meta">—</div>
    }
  </div>
</div>
